import React from 'react'
import { Button, Typography, Space } from 'antd'
import { ImportOutlined } from '@ant-design/icons'

const { Paragraph } = Typography

export default function ExampleBlock({ description, exampleLines = [], onCopy }) {
  return (
    <div style={{ background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 8, padding: 12 }}>
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        {description && <Paragraph style={{ margin: 0 }}>{description}</Paragraph>}
        {exampleLines.length > 0 && (
          <ul style={{ marginLeft: 18, marginBottom: 0 }}>
            {exampleLines.map((l, i) => <li key={i}>{l}</li>)}
          </ul>
        )}
        {onCopy && (
          <Button size="small" type="primary" icon={<ImportOutlined />} onClick={onCopy}>
            Copy to Calculator Wizard
          </Button>
        )}
      </Space>
    </div>
  )
}
